import React from 'react';

import Spinner from './Spinner';

const BiomeSummaryLoading = (props) => {
  return (
    <div className="BiomeSummaryLoading">
      <p className="BiomeSummaryLoading__title">
        Loading...
      </p>
      <Spinner />
    </div>
  );
};

export default BiomeSummaryLoading;



// WEBPACK FOOTER //
// ./src/components/BiomeSummaryLoading.js